var _radialGradient, _path, _linearGradient, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Prize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "QCc7wBF64Um4SwN2DFvxja",
    cx: 23.943,
    cy: 18.921,
    r: 22.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#871233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.718,
    stopColor: "#8e1336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812,
    stopColor: "#a3163e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#bc1948"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#QCc7wBF64Um4SwN2DFvxja)",
    d: "M34,27.765H14v18.234c0,0.777,0.848,1.257,1.514,0.857L24,41.765l8.486,5.091 c0.667,0.4,1.514-0.08,1.514-0.857V27.765z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "QCc7wBF64Um4SwN2DFvxjb",
    x1: 14.849,
    x2: 33.078,
    y1: 3.094,
    y2: 34.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb705"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#QCc7wBF64Um4SwN2DFvxjb)",
    d: "M41.035,17.294l-1.258-0.756c-0.536-0.322-0.898-0.851-1.062-1.454 c-0.004-0.011-0.005-0.022-0.009-0.034c-0.167-0.608-0.117-1.256,0.189-1.807l0.713-1.283c0.729-1.312-0.203-2.929-1.705-2.954 L36.422,8.98c-0.628-0.011-1.21-0.29-1.652-0.733c-0.005-0.005-0.009-0.009-0.014-0.014C34.31,7.79,34.033,7.207,34.022,6.58 l-0.025-1.481c-0.025-1.501-1.642-2.434-2.954-1.705L29.76,4.107c-0.553,0.306-1.199,0.356-1.807,0.189 c-0.011-0.004-0.022-0.005-0.034-0.009c-0.603-0.164-1.132-0.526-1.454-1.062l-0.756-1.258c-0.772-1.287-2.639-1.287-3.411,0 L21.546,3.22c-0.324,0.54-0.859,0.905-1.465,1.071c-0.007,0.002-0.013,0.004-0.02,0.005c-0.614,0.169-1.265,0.119-1.822-0.191 l-1.278-0.709c-1.312-0.729-2.929,0.203-2.954,1.705L13.98,6.58c-0.011,0.626-0.29,1.21-0.733,1.652 c-0.005,0.004-0.011,0.009-0.014,0.014c-0.443,0.445-1.026,0.722-1.652,0.733l-1.481,0.025c-1.501,0.025-2.434,1.64-1.705,2.954 l0.713,1.283c0.306,0.553,0.356,1.199,0.189,1.807c-0.005,0.011-0.007,0.023-0.011,0.034c-0.164,0.603-0.527,1.132-1.062,1.454 l-1.258,0.756c-1.287,0.772-1.287,2.639,0,3.411l1.258,0.756c0.536,0.322,0.898,0.851,1.062,1.454 c0.004,0.011,0.005,0.022,0.009,0.034c0.167,0.608,0.117,1.256-0.189,1.807l-0.713,1.283c-0.729,1.312,0.203,2.929,1.705,2.954 l1.481,0.025c0.628,0.011,1.21,0.29,1.652,0.733c0.005,0.005,0.009,0.009,0.014,0.014c0.445,0.443,0.722,1.026,0.733,1.652 l0.025,1.481c0.025,1.501,1.642,2.434,2.954,1.705l1.283-0.713c0.553-0.306,1.199-0.356,1.807-0.189 c0.011,0.004,0.023,0.005,0.034,0.009c0.603,0.164,1.132,0.526,1.454,1.062l0.756,1.258c0.772,1.287,2.639,1.287,3.411,0 l0.756-1.258c0.322-0.536,0.851-0.898,1.454-1.062c0.011-0.004,0.023-0.005,0.034-0.009c0.608-0.167,1.256-0.117,1.807,0.189 l1.283,0.713c1.312,0.729,2.929-0.203,2.954-1.705l0.025-1.481c0.011-0.628,0.29-1.21,0.733-1.652 c0.005-0.005,0.009-0.009,0.014-0.014c0.443-0.445,1.026-0.722,1.652-0.733l1.481-0.025c1.501-0.025,2.434-1.642,1.705-2.954 l-0.713-1.283c-0.306-0.553-0.356-1.199-0.189-1.807c0.004-0.011,0.005-0.022,0.009-0.034c0.164-0.603,0.526-1.132,1.062-1.454 l1.258-0.756C42.322,19.932,42.322,18.067,41.035,17.294z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 19,
    r: 10,
    fill: "none",
    stroke: "#ffdf26",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Prize);
export default __webpack_public_path__ + "static/media/icons8-prize.f3acaf82ae2e0878adc3ad56dda0120a.svg";
export { ForwardRef as ReactComponent };